import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "epscolorspace"
    }}>{`EPSColorSpace`}</h1>
    <p>{`Color space options for representing color in the exported EPS.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RGB`}</strong>{` = 1666336578`}</p>
      <p parentName="blockquote">{`Represents all color values using the RGB color space. Best suited for documents that will be viewed on-screen.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CMYK`}</strong>{` = 1129142603`}</p>
      <p parentName="blockquote">{`Creates a separable file by representing all color values using the gamut of CYMK process color inks.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`GRAY`}</strong>{` = 1766290041`}</p>
      <p parentName="blockquote">{`Converts all color values to high-quality black-and-white images. Gray levels of the converted objects represent the luminosity of the original objects.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UNCHANGED_COLOR_SPACE`}</strong>{` = 1970161251`}</p>
      <p parentName="blockquote">{`Leaves each image in its original color space.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`POSTSCRIPT_COLOR_MANAGEMENT`}</strong>{` = 1164208483`}</p>
      <p parentName="blockquote">{`Uses PostScript color management (includes profiles).`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      